/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { FlattenedDataState } from '../UNSAFE_Collection';
import { Keys } from '../utils/UNSAFE_keys';

/**
 * Helper function to only include keys of leaf items.
 */
export const excludeGroup = <K, D>(data: FlattenedDataState<K, D>, keys: Keys<K>) => {
  if (!keys.all) {
    const groups = data.data
      .filter((dataMetadata) => {
        return !dataMetadata.metadata.isLeaf;
      })
      .map((dataMetadata) => {
        return dataMetadata.metadata.key;
      });
    const leafOnly = Array.from(keys.keys.values()).filter((key: K) => {
      return !groups.includes(key);
    });
    return { ...keys, keys: new Set(leafOnly) };
  }
  return keys;
};
